export default
  "Politique de confidentialité Solution Éco France — traitement RGPD des données, finalités, durées de conservation, sous-traitants, droits CNIL, contact DPO.";
